{
  "name": "@chancenwerk/chancenfamily",
  "displayName": "ChancenFamily",
  "description": "The ChancenFamily is a service of the Chancenwerk e.V.",
  "version": "1.0.1",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production --node-port 7000 --listen-port 3000",
    "test": "adornis-cli project test"
  },
  "dependencies": {
    "@adornis/base": "catalog:",
    "@adornis/baseql": "catalog:",
    "@adornis/chemistry": "catalog:",
    "@adornis/cms": "catalog:",
    "@adornis/config": "catalog:",
    "@adornis/data-view": "catalog:",
    "@adornis/field-management": "catalog:",
    "@adornis/fonts": "catalog:",
    "@adornis/filter": "catalog:",
    "@adornis/functional-lit": "catalog:",
    "@adornis/internationalization": "catalog:",
    "@adornis/router": "catalog:",
    "@adornis/user-forms": "catalog:",
    "@adornis/users": "catalog:",
    "@chancenwerk/client": "workspace:^",
    "@chancenwerk/translation-data": "workspace:^",
    "@chancenwerk/shared": "workspace:^",
    "@chancenwerk/config": "workspace:^",
    "@chancenwerk/family": "workspace:^",
    "@chancenwerk/server": "workspace:^",
    "@lit-labs/preact-signals": "catalog:",
    "construct-style-sheets-polyfill": "catalog:",
    "lit": "catalog:",
    "luxon": "catalog:",
    "mingo": "catalog:",
    "qrcode": "catalog:",
    "rxjs": "catalog:"
  },
  "devDependencies": {
    "@adornis/cli": "catalog:"
  },
  "files": [
    "dist"
  ],
  "license": "ISC"
}
